import { ChangeDetectorRef, Component, NgZone, OnDestroy } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Observable, Subject, takeUntil } from "rxjs";
import { map, shareReplay } from "rxjs/operators";
import { UserInterface } from "../../_shared/interfaces/user.interface";
import { AuthenticationService } from "../../_shared/services/authentication.service";
import { environment } from "../../../environments/environment";
import { CustomerInterface } from "../../_shared/interfaces/customer.interface";
import { CustomerService } from "../../_shared/services/customer.service";
import { ScrollDispatcher } from "@angular/cdk/overlay";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "gnl-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class SecureLayoutComponent implements OnDestroy {
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  isLargeScreen$: Observable<boolean> = this.breakpointObserver
    .observe("(min-width: 1400px)")
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  authenticatedUser$: Observable<UserInterface | undefined>;

  version = environment.appVersion;
  customer$: Observable<CustomerInterface>;
  isSticky = false;

  navLinks = [
    { path: "/secure/dashboard", icon: "home", title: "Main Menu" },
    {
      path: "/secure/orders/overview",
      icon: "pending_actions",
      title: "Open / Unbilled Orders",
    },
    {
      path: "/secure/payments/history",
      icon: "account_balance",
      title: "Payment History",
    },
    {
      path: "/secure/invoices/history",
      icon: "receipt_long",
      title: "Invoice History",
    },
    { path: "/secure/whats-new", icon: "campaign", title: "What's New" },
    { path: "/secure/my-account", icon: "portrait", title: "My Account" },
    { path: "/logout", icon: "logout", title: "Log Out" },
  ];
  private onDestroy = new Subject<void>();

  constructor(
    private titleService: Title,
    private breakpointObserver: BreakpointObserver,
    private authService: AuthenticationService,
    private customerService: CustomerService,
    private scrollDispatcher: ScrollDispatcher,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    this.titleService.setTitle("Customer Portal | Ganahl Lumber");
    this.authenticatedUser$ = this.authService.getAuthenticatedUser$();
    this.customer$ = this.customerService.getCustomer();
    this.scrollDispatcher
      .scrolled()
      .pipe(takeUntil(this.onDestroy))
      .subscribe((scrollable: any) => {
        // Handle scroll event here
        if (scrollable) {
          const scrollTop = scrollable.getElementRef().nativeElement.scrollTop;
          // Apply your custom logic based on the scroll position
          const newSticky = scrollTop > 0 ? true : false; // Example: set isSticky based on scroll position
          if (newSticky !== this.isSticky) {
            this.isSticky = newSticky;
            this.changeDetectionRef.detectChanges();
          }
        }
      });
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
